import {assertAndContinue} from 'Asserts';
import {pluralize} from 'BenchlingUtil';
import {assertNever} from 'util/Types';

import {colNumberToLetters, rowIndexToNumber} from '../excess/Util';
import {SelectionRange, TableDimension} from '../TableConstants';

/**
 * Return a string call to action (CTA) for performing an operation on one or more rows or columns.
 */
export default function getDimensionalOperationText({
  verb,
  selectionRange,
  dimension,
}: {
  verb: string;
  selectionRange: SelectionRange | null;
  dimension: TableDimension;
}): string {
  if (selectionRange != null && selectionRange.minIndex !== selectionRange.maxIndex) {
    const start = getHumanReadableDimensionIndex(selectionRange.minIndex, dimension);
    const stop = getHumanReadableDimensionIndex(selectionRange.maxIndex, dimension);
    return `${verb} ${pluralize(2, dimension)} ${start} - ${stop}`;
  } else {
    return `${verb} ${dimension}`;
  }
}

function getHumanReadableDimensionIndex(index: number, dimension: TableDimension): string {
  switch (dimension) {
    case TableDimension.ROW:
      return rowIndexToNumber(index).toLocaleString();
    case TableDimension.COLUMN:
      return colNumberToLetters(index);
    default:
      assertAndContinue(false, `Invalid dimension ${assertNever(dimension)}`);
      return rowIndexToNumber(index).toLocaleString(); // Fall back to numerical indices to avoid hard error
  }
}
